<template>
  <div class="col-lg-6">
    <div :class="{ block: layout === 'v1' }">
      <div :class="{ 'block-header block-header-default': layout === 'v1' }">
        <h3
          :class="{ 'block-title': layout === 'v1', 'mb-2': layout === 'v2' }"
        >
          Resources
        </h3>
      </div>
      <div class="block-content d-flex flex-column pb-4">
        <a
          href="https://form.asana.com/?k=zWRoMnT3cwbm6SBGWoWXgA&d=4648722092576"
          target="_blank"
        >
          Service Request Form
        </a>
        <a
          href="https://form.asana.com/?k=oQRhIrzqtFL1mgGVD1We7g&d=4648722092576"
          target="_blank"
        >
          Passholder Messaging Request Form
        </a>
        <a
          href="https://form.asana.com/?k=gQR2GrY518pc3moANnMhRg&d=4648722092576"
          target="_blank"
        >
          Collateral Request Form
        </a>
        <a
          href="https://app.bandwango.com/Bandwango-Report-Descriptions.pdf"
          target="_blank"
        >
          Bandwango Report Descriptions
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    layout: {
      type: String,
      default: 'v1'
    }
  },
  data() {
    return {};
  }
};
</script>
